import {
  sendFollowUpEmail,
} from 'actions/follow-up-email';

const followUpEmail = () => {
  const initialState = {
    response: null,
  };

  return (
    state = initialState,
    {
      type,
      response,
    },
  ) => {
    switch (type) {
      case sendFollowUpEmail.requestTypes.REQUEST:
        return {
          ...state,
          response: null,
        };

      case sendFollowUpEmail.requestTypes.SUCCESS:
        return {
          ...state,
          response,
        };

      case sendFollowUpEmail.requestTypes.FAILURE:
        return {
          ...state,
          response: null,
        };

      default:
        return state;
    }
  };
};

export default followUpEmail();
